
import { Component, Input, OnChanges } from '@angular/core';
import { Router } from '@angular/router';
import { PerformanceService } from '../../../services/performance.service';
import { ConstantsService } from '../../../../shared/services/constants.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'ara-training-status',
  templateUrl: './training-status.component.html',
  styleUrls: ['./training-status.component.css']
})
export class TrainingStatusComponent implements OnChanges {
  @Input() TrainingStatusData;
  @Input() selectedUnit: any;
  @Input() year: any;
  @Input() MonthRange: any;
  rows : any[];
  cols: any[] = [];
  header: any[] = [];
  clonedData:any[]=[];
  IsEdit:boolean = false;
  TrainingData : any;
  constructor(private PDService: PerformanceService,private router: Router) { }

  ngOnChanges(): void {
    if(this.TrainingStatusData){
        this.cols = [];
        this.rows = [];
        this.header = [];
        this.header = this.TrainingStatusData[0].Headers;
        this.rows = this.TrainingStatusData[0].Rows;
        if(this.header){
          this.header.forEach(element => {
            this.cols.push({'field': this.header.indexOf(element),'header':element })
          });
        }
        if(this.rows){
          this.rows.forEach((element,index) => {
            element.Id = index+1;
          });
        }
    }
  }

  onRowEditInit(data: any) {
    this.clonedData[data.Id] = { ...data };
  }

  onRowEditSave(data: any,ri:number) {
    if (data.Id > 0) {
      if(this.clonedData){
        data.forEach((element,index) => {
          if(index != 0){
            if(data[index] != this.clonedData[data.Id][index]){
              this.rows[this.rows.length - 1][index] = this.rows[this.rows.length - 1][index] - this.clonedData[data.Id][index] + data[index]
            }
          }
        });
        this.clonedData = [];
      }
    }
  }

  onRowEditCancel(data: any, index: number) {
    this.clonedData = [];
  }

  GetTrainingStatusSelectedDetails(rowdata,col){
  
    const apiRequest = {
      Model: {
        "Units": this.selectedUnit,//this.child1.selectedUnit,
        "Year": this.year,//this.child1.year,
        "Months":this.MonthRange,//this.child1.MonthRange,
        "ModuleName":"Training Status",
        "Component":rowdata[1] === "Total" || rowdata[1] === "" || rowdata[1] === null ? 0 : rowdata[0],
         "Column":col.field,
        "ColumnName":col.header
     }
    };

    this.PDService.getPDSelectedDetails(apiRequest,this.callbackMethodForGetTrainingStatusSelectedDetails.bind(this));
  }
  callbackMethodForGetTrainingStatusSelectedDetails(response){
    if(response.Success)
    this.TrainingData = response.Result;
  }

  Redirect(value,UnitId)
  {
  //this.router.navigate(['/tnc/assign-training/', value, { unitId:UnitId }])
  window.open(ConstantsService.URL.APP + ['/tnc/assign-training/'+value+';unitId='+UnitId], '_self');
  }
  
  //BOC Pritesh
  exportToExcel()
  {

  let element = document.getElementById('TrainingStatusTableToExport');
  const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);
 
  //ws['!ref'] = ws['!ref'].replace('T','S');//to remove Actions Column
  /* generate workbook and add the worksheet */
  const wb: XLSX.WorkBook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

  /* save to file */  
  XLSX.writeFile(wb, "TrainingStatus.xlsx");

  }
  //EOC Pritesh

}
